<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {unescape} from 'lodash-es'
    import {hotelAddressToString} from '~/utils/helpers'

    @Component
    export class OfflineServiceLinkingHotelMixin extends Vue {
        showLinkedHotelModal = false
        isDeleteLinkedHotel = false
        hotelInfo = null

        showLinkedHotel() {
            if (!this.product.hotelId) this.showLinkedHotelModal = true
            else {
                delete this.product.hotelId
                this.isDeleteLinkedHotel = true
            }
        }

        async saveHotelLink(hotelInfo) {
            this.hotelInfo = hotelInfo
            this.product.hotelId = hotelInfo.hotelId || hotelInfo.localMappedHotelId
            this.name = hotelInfo.hotelName
            this.address = hotelAddressToString(hotelInfo.address)
            if (hotelInfo?.descriptions?.description?.length) {
                const descriptions = this.getDescriptions(hotelInfo.descriptions.description)
                this.description = descriptions
                    .reduce((descriptions, item) => {
                        descriptions.push(`<h4>${this.descriptionTypeLabel(item)}</h4>`)
                        descriptions.push(`<p>${item.descriptions.join('</p><p>')}</p>`)

                        return descriptions
                    }, [])
                    .join('')
                toRaw(this.editor).setData(this.description)
            }
        }

        //TODO: duplicate code from HotelInfoDescriptions
        descriptionTypeLabel(description) {
            if (this.$te(`description_type.${description?.type.toLowerCase()}`)) {
                return this.$t(`description_type.${description?.type.toLowerCase()}`)
            }

            return description?.type
        }

        //TODO: duplicate code from HotelInfoDescriptions
        getDescriptions(descriptions) {
            const groupedDescriptions = []
            descriptions.forEach(description => {
                const groupedDescriptionIndex = groupedDescriptions.findIndex(
                    groupedDescription => groupedDescription.type === description.type
                )
                if (groupedDescriptionIndex === -1) {
                    groupedDescriptions.push({
                        type: description.type,
                        descriptions: [unescape(description.description)],
                    })
                } else {
                    groupedDescriptions[groupedDescriptionIndex].descriptions.push(unescape(description.description))
                }
            })
            groupedDescriptions
                .sort(item => (item.type === 'general' ? -1 : 1))
                .sort(item => (item.type === 'short' ? -1 : 1))
            if (
                groupedDescriptions[0] &&
                groupedDescriptions[0].type === 'short' &&
                groupedDescriptions[1] &&
                groupedDescriptions[1].type === 'general' &&
                groupedDescriptions[1].descriptions[0].indexOf(groupedDescriptions[0].descriptions[0]) !== -1
            ) {
                groupedDescriptions.splice(0, 1)
            }
            return groupedDescriptions
        }
    }

    export default OfflineServiceLinkingHotelMixin
</script>
